import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, DataGrantDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import DataGrantInline, { DataGrantInlineProps } from "./DataGrantInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: DataGrantDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<DataGrantInlineProps>;
}

export default function DataGrantLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.DataGrantRead]}
      to={ROUTE_PATH.DATA_GRANT_VIEW(entity?.id || entityId || "")}
      content={<DataGrantInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
